// Shared between the header (which renders the quote), the edit modal and the
// Konfigurimet page that reviews what has been published.

// The single record the header reads:
// { date, quote, quoteEn, author, source, occasion, editedBy? }.
export const QOTD_FIELD_ID = "9d4c8f40-3a6d-11ed-a92c-178f43e8cbef";

// The last few months of picks, written by the daily Lambda.
export const QUOTE_HISTORY_FIELD_ID = "69bbd003-3b91-4b5a-bdf4-d77e0b27c747";

// Quotes and authors the daily pick must never choose again.
export const QUOTE_BLOCKLIST_FIELD_ID = "f2a5769b-7de5-42e6-bd99-72e558128165";

// How each published line came about.
export const QUOTE_SOURCES = {
  ai: { label: "Zgjedhur me inteligjencë artificiale", color: "blue" },
  fallback: { label: "Zgjedhur automatikisht", color: "default" },
  wish: { label: "Urim feste", color: "purple" },
};

export const sourceTag = (source) =>
  QUOTE_SOURCES[source] || { label: "E panjohur", color: "default" };
